import script from "./physical-links.vue?vue&type=script&lang=js"
export * from "./physical-links.vue?vue&type=script&lang=js"

import "./physical-links.vue?vue&type=style&index=0&id=5c337552&lang=scss"

const __exports__ = script;

export default __exports__